export default __webpack_public_path__ + "static/media/ptac-logo2.a591ca0d.png";